import ProjectTask from "@/views/Project/ProjectTask";
import ProjectCreate from "@/views/Project/ProjectCreate";
import ProjectMy from "@/views/Project/ProjectMy";
import ProjectMyDetail from "@/views/Project/ProjectMyDetail";
import ChallengeTask from "@/views/Challenge/ChallengeTask";
import ChallengeCreate from "@/views/Challenge/ChallengeCreate";
import ChallengeMy from "@/views/Challenge/ChallengeMy";
import ChallengeDetail from "@/views/Challenge/ChallengeDetail";
import SkillWikiList from "@/views/SkillWiki/SkillWikiList";
import DemandList from "@/views/Demand/DemandMyList.vue";
import ColumnList from "@/views/Column/ColumnList";
export default [
  {
    path: "content",
    name: "content",
    component: { render: h => h("router-view") },
    meta: {
      nav: {
        icon: "el-icon-s-management",
        title: "内容建设"
      },
      breadcrumb: {
        title: "内容建设",
        replace: false
      }
    },
    children: [
      {
        path: "demand",
        name: "Demand",
        component: { render: h => h("router-view") },
        meta: {
          title: "极客-内容建设-需求/选题",
          nav: {
            title: "需求/选题"
          },
          breadcrumb: {
            title: "需求/选题",
            replace: false
          }
        },
        children: [
          {
            path: "/my",
            name: "DemandList",
            redirect: { name: "DemandListSelf" },
            component: { render: h => h("router-view") },
            permission:
              "feedback_service.api.jiker_fuwu_admin.project_applications.index",
            children: [
              {
                path: "",
                name: "DemandListSelf",
                component: DemandList,
                meta: {
                  title: "极客-极客百科-我的选题",
                  nav: {
                    title: "我的选题"
                  },
                  breadcrumb: {
                    title: "我的选题",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: "skill/knowledge/",
        name: "SkillWiki",
        component: { render: h => h("router-view") },
        meta: {
          title: "极客-内容建设-极客百科",
          nav: {
            title: "极客百科"
          },
          breadcrumb: {
            title: "极客百科",
            replace: false
          }
        },
        children: [
          {
            path: "list",
            name: "SkillWikiList",
            redirect: { name: "SkillWikiListSelf" },
            component: { render: h => h("router-view") },
            permission: "kcell.api.jiker.fuwu_admin.stack_build_tasks.index",
            children: [
              {
                path: "",
                name: "SkillWikiListSelf",
                component: SkillWikiList,
                meta: {
                  title: "极客-极客百科-百科建设",
                  nav: {
                    title: "百科建设"
                  },
                  breadcrumb: {
                    title: "百科建设",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: "column/list",
        name: "ColumnList",
        permission: "column.api.jiker_fuwu.columns.build.index",
        component: ColumnList,
        meta: {
          title: "极客-内容建设-专栏文章",
          nav: {
            title: "专栏文章"
          },
          breadcrumb: {
            title: "专栏文章",
            replace: false
          }
        }
        // children: [
        //   {
        //     path: "list",
        //     name: "ColumnList",
        //     redirect: { name: "ColumnListSelf" },
        //     component: { render: h => h("router-view") },
        //     children: [
        //       {
        //         path: "",
        //         name: "ColumnListSelf",
        //         component: ColumnList,
        //         meta: {
        //           title: "极客-内容建设-专栏文章-列表",
        //           nav: {
        //             title: "专栏文章"
        //           },
        //           breadcrumb: {
        //             title: "专栏文",
        //             replace: false
        //           }
        //         }
        //       }
        //     ]
        //   }
        // ]
      },
      {
        path: "project",
        name: "Project",
        component: { render: h => h("router-view") },
        meta: {
          title: "极客-项目设计-需求列表",
          nav: {
            icon: "el-icon-tickets",
            title: "项目设计"
          },
          breadcrumb: {
            title: "项目设计",
            replace: false
          }
        },
        children: [
          {
            path: "task",
            name: "ProjectTask",
            redirect: { name: "ProjectTaskSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "ProjectTaskSelf",
                component: ProjectTask,
                permission: "project.api.fuwu_admin.project_tasks.index",
                meta: {
                  title: "极客-项目设计-设计任务",
                  nav: {
                    icon: "el-icon-tickets",
                    title: "设计任务"
                  },
                  breadcrumb: {
                    title: "设计任务",
                    replace: false
                  }
                }
              },
              {
                path: ":id/create",
                name: "ProjectCreate",
                component: ProjectCreate,
                permission: "project.api.fuwu_admin.projects.store",
                meta: {
                  title: "极客-项目设计-概要提案",
                  breadcrumb: {
                    title: "概要提案",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "my",
            name: "ProjectMy",
            redirect: { name: "ProjectMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "ProjectMySelf",
                component: ProjectMy,
                permission: "project.api.fuwu_admin.projects.index",
                meta: {
                  title: "极客-项目设计-我的项目",
                  nav: {
                    title: "我的项目"
                  },
                  breadcrumb: {
                    title: "我的项目",
                    replace: false
                  }
                }
              },
              {
                path: ":id",
                name: "ProjectMyDetail",
                component: ProjectMyDetail,
                permission: "project.api.fuwu_admin.projects.show",
                meta: {
                  title: "极客-项目详情",
                  breadcrumb: {
                    title: "项目详情",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: "challenge",
        name: "Challenge",
        component: { render: h => h("router-view") },
        meta: {
          title: "极客-挑战设计",
          nav: {
            icon: "el-icon-notebook-2",
            title: "挑战设计"
          },
          breadcrumb: {
            title: "挑战设计",
            replace: false
          }
        },
        children: [
          {
            path: "task",
            name: "ChallengeTask",
            redirect: { name: "ChallengeTaskSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "ChallengeTaskSelf",
                component: ChallengeTask,
                permission:
                  "challenge_service.api.fuwu_admin.challenge_tasks.index",
                meta: {
                  title: "极客-挑战设计-挑战任务",
                  nav: {
                    icon: "el-icon-tickets",
                    title: "挑战任务"
                  },
                  breadcrumb: {
                    title: "挑战任务",
                    replace: false
                  }
                }
              },
              {
                path: ":id/create",
                name: "ChallengeCreate",
                component: ChallengeCreate,
                permission:
                  "challenge_service.api.fuwu_admin.my_challenges.store",
                meta: {
                  title: "极客-挑战设计-创建挑战",
                  breadcrumb: {
                    title: "创建挑战",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "my",
            name: "ChallengeMy",
            redirect: { name: "ChallengeMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "ChallengeMySelf",
                component: ChallengeMy,
                permission:
                  "challenge_service.api.fuwu_admin.my_challenges.index",
                meta: {
                  title: "极客-挑战设计-我的挑战",
                  nav: {
                    title: "我的挑战"
                  },
                  breadcrumb: {
                    title: "我的挑战",
                    replace: false
                  }
                }
              },
              {
                path: ":id",
                name: "ChallengeDetail",
                component: ChallengeDetail,
                permission:
                  "challenge_service.api.fuwu_admin.my_challenges.show",
                meta: {
                  title: "极客-挑战详情",
                  breadcrumb: {
                    title: "挑战详情",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  }
];
